import {
  getQueryStringParams,
  setQueryStringParam,
  deleteQueryStringParam,
} from "../../shared/utils";

function convertToNonNullArray(value) {
  if (typeof value === "string") {
    // split the string into an array based on a delimiter (e.g., comma)
    // filter out empty strings and "NaN" values
    return value.split(",").filter((v) => !!v && v !== "NaN");
  }

  return [];
}

const { currentAccount } = window;
const defaultPercentile = currentAccount?.default_percentile || "vs_75th";

export const snapshotResultFiltersStore = {
  squadIds:
    convertToNonNullArray(getQueryStringParams().get("squad_ids")) || [],
  groupIds:
    convertToNonNullArray(getQueryStringParams().get("group_ids")) || [],
  filterType: getQueryStringParams().get("group_ids") ? "groups" : "teams",
  activeTab: getQueryStringParams().get("view") || "all-teams",
  tagIds: convertToNonNullArray(getQueryStringParams().get("tag_ids")) || [],
  compareTo: getQueryStringParams().get("ct") || defaultPercentile,
  aggregationTagGroup: getQueryStringParams().get("atg"),
  aggregation: getQueryStringParams().get("aggregation") || "team",
  previousSnapshotId: null,
  sortBy: getQueryStringParams().get("sb") || "score",
  sortReverse:
    getQueryStringParams().get("sr") == null ||
    getQueryStringParams().get("sr") == "true",
  drilldownSortBy: getQueryStringParams().get("ddsb") || "snapshotSquadName",
  drilldownSortReverse: getQueryStringParams().get("ddsr") == "true",
  selectedDrilldownTab: getQueryStringParams().get("ddt"),
  branch: getQueryStringParams().get("branch"),
  init() {
    const compareValue = getQueryStringParams().get("ct") || defaultPercentile;
    const aggregationTagGroupValue = getQueryStringParams().get("atg");

    this.previousSnapshotId = getQueryStringParams().get("prev_ss");

    this.setCompareTo(
      this.previousSnapshotId ? `ss-${this.previousSnapshotId}` : compareValue,
      true,
    );

    if (aggregationTagGroupValue)
      this.setAggregationTagGroup({ encoded_id: aggregationTagGroupValue });

    // Set up event listeners for squad and group changes
    window.addEventListener("change-squad-ids", (e) => {
      this.setSquadIds(e.detail);
    });

    window.addEventListener("change-group-ids", (e) => {
      this.setGroupIds(e.detail);
    });
  },
  setSquadIds(ids) {
    // Filter out invalid values (NaN, null, undefined, non-positive numbers)
    const validIds = ids || [];
    const filteredIds = validIds.filter((id) => !isNaN(id) && id > 0);

    this.squadIds = filteredIds;
    this.groupIds = []; // Clear groups when squads are selected
    this.filterType = "teams";

    if (filteredIds.length > 0) {
      setQueryStringParam("squad_ids", filteredIds.join(","));
      deleteQueryStringParam("group_ids");
    } else {
      deleteQueryStringParam("squad_ids");
    }
  },
  setGroupIds(ids) {
    this.groupIds = ids || [];
    this.squadIds = []; // Clear squads when groups are selected
    this.filterType = "groups";

    if (ids && ids.length > 0) {
      setQueryStringParam("group_ids", ids.join(","));
      deleteQueryStringParam("squad_ids");
    } else {
      deleteQueryStringParam("group_ids");
    }
  },
  setCompareTo(value, initialLoad) {
    const prefix = "ss-";
    const isPriorSnapshot = value?.startsWith(prefix);

    if (isPriorSnapshot) {
      const snapshotId = value.replace(prefix, "");

      this.compareTo = "vs_prev";
      setQueryStringParam("ct", "vs_prev");
      this.previousSnapshotId = snapshotId;
      setQueryStringParam("prev_ss", snapshotId);
    } else {
      this.compareTo = value;
      if (!initialLoad) {
        setQueryStringParam("ct", value);
      }
      this.previousSnapshotId = null;
      deleteQueryStringParam("prev_ss");
    }
  },
  setAggregationTagGroup(option) {
    if (!option) {
      this.aggregationTagGroup = null;
      deleteQueryStringParam("atg");
      return;
    }

    const name = option?.name;
    this.aggregationTagGroup = option;

    if (name) {
      setQueryStringParam("atg", option.encoded_id);
    }
  },
  setAggregation(value) {
    this.aggregation = value;
    if (value) {
      setQueryStringParam("aggregation", value);
    } else {
      deleteQueryStringParam("aggregation");
    }
  },
};
